<template>
  <div class="flex flex-col gap-1 border border-[#31e8a8] cursor-pointer rounded-md p-2" @click="model = true">
    <niceone-image :src="$publicPath('/images/payment/tabby.svg')" width="41"/>

    <div class="flex items-end">
      <slot name="description"></slot>
      <van-icon class="flip-icon" name="arrow"/>
    </div>
  </div>

  <responsive-model v-model="model" :style="{ height: $device.isDesktop ? '500px' : '100%' }" closeable hide-action-btn
                    size="md">
    <iframe
        :src="`https://checkout.tabby.ai/promos/product-page/installments/${$i18n.locale}/?price=${price}&currency=${currency}`"
        height="100%"
        title="Tabby Payment Info"
        width="100%"
    />
  </responsive-model>
</template>

<script setup>
import {useCurrencyStore} from "@/store/currency";
import ResponsiveModel from "~/components/common/dialogs/responsive.vue";

const {locale} = useI18n()
defineProps({
  price: {
    type: Number,
    default: 0
  }
})

const model = ref(false)

const currencyStore = useCurrencyStore()
const {currency} = storeToRefs(currencyStore)
</script>